export const FileCategory = {
  IMAGE: 'image/*',
};

export const FileType = {
  [FileCategory.IMAGE]: {
    PNG: '.png',
    JPG: '.jpg',
    JPEG: '.jpeg',
    GIF: '.gif',
    HEIC: '.heic',
  },
};

export const FileTypeLabel = {
  [FileType[FileCategory.IMAGE].PNG]: 'PNG',
  [FileType[FileCategory.IMAGE].JPG]: 'JPG',
  [FileType[FileCategory.IMAGE].JPEG]: 'JPEG',
  [FileType[FileCategory.IMAGE].GIF]: 'GIF',
  [FileType[FileCategory.IMAGE].HEIC]: 'HEIC',
};

export const AcceptFileTypes = Object.values(FileType[FileCategory.IMAGE]);

export const DropzoneAcceptFiles = {
  [FileCategory.IMAGE]: AcceptFileTypes,
};
